module.exports = __webpack_public_path__ + "img/special-disbursement-project.b2a77d4c.svg";